// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { bannerStyles } from "@insite/content-library/Widgets/Category/CategoryDetailBanner";
import { color } from "@plumberssupply/XDL/Utilities";
import { css } from "styled-components";


bannerStyles.container = {
    css:css`
        font-size: 16px;
        font-weight: 400;
        line-height: 26px;
        
        h2 {
            color: ${color("common.ui11")};
            margin-bottom: 16px;  
        }
    `
}